import FormattedMessage from 'I18n/components/FormattedMessage';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { HIGHLIGHT_STAGE } from '../../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const Stage = ({
  value
}) => /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
  "data-test-id": HIGHLIGHT_STAGE,
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "highlightCard.propertyLabels.stage"
  }),
  value: value
});
export default Stage;